// Implements: F-USG-006
/**
 * Which versions the per-version breakdown of Mi consumo lists (mockup v3 P7, v3 `verBreakdown`):
 * the eight newest, by number, and how many older ones it leaves out ("Y 3 versiones más
 * antiguas."). Only the listed ones have their cost asked for.
 */

import type { VersionTreeNode } from "../../../types/api";

/** The most versions one breakdown lists (v3). */
export const BREAKDOWN_ROWS = 8;

export interface BreakdownVersions {
  readonly shown: readonly VersionTreeNode[];
  readonly older: number;
}

export function breakdownVersions(nodes: readonly VersionTreeNode[]): BreakdownVersions {
  const newest = [...nodes].sort((left, right) => right.sequence_number - left.sequence_number);
  const shown = newest.slice(0, BREAKDOWN_ROWS);
  return { shown, older: newest.length - shown.length };
}
